export function getFail(action, combatantMap, currentCombatantStateChanges, combatantModels) {

  //Copy the changes.
  let changes = {
    ...currentCombatantStateChanges
  };

  const casterModel = combatantModels[combatantMap.casterId];
  const targetModels = combatantMap.targetIds.map(combId => combatantModels[combId]);

  //Add stuff to the changes
  if (action.shouldFail(action, casterModel, targetModels)) {
    changes["didFail"] = true;
  }

  //Auto fail if empty targetModels array
  if (targetModels.length === 0) {
    //Targets are filtered for only alive, only dead etc. Sometimes an empty targets array can end up slip through the cracks.
    //If that happens, this move should auto fail.
    //console.log('auto failing because of empty targetModels array', action.name)
    changes["didFail"] = true;
  }


  return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/fail.js